import { Button, DetailListContact } from '@presentation/components';
import { PLACEHOLDER_IMAGE } from '@presentation/constants';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import * as Styled from '../../styled';
import type { ProPageProps } from '../../types';

export const ProContactInfos: FC<ProPageProps> = (props) => {
  const {
    showContactInfo,
    onShowContactInfo,
    city,
    header,
    slideshow,
    contactInfo,
    proType,
    enableWhatsAppContact = false,
    onWhatsappClick,
  } = props;
  const { translate } = useTranslation();

  const image = useMemo(() => {
    return slideshow?.items?.find((item) => !item.isVideo);
  }, [slideshow?.items]);

  return (
    <Styled.ContactInfosContainer>
      <Styled.ProContactInfosTitleWrapper>
        {image && (
          <Styled.ProContactInfosImg src={image.src ?? PLACEHOLDER_IMAGE} alt="pro-avatar-image" />
        )}
        <div>
          <h5>{header?.title}</h5>
          <Styled.ProContactInfosType>
            {translate(`enum.proType.${proType}`)}
          </Styled.ProContactInfosType>
        </div>
      </Styled.ProContactInfosTitleWrapper>
      {!showContactInfo && !enableWhatsAppContact ? (
        <Styled.ProContactInfosLocationWrapper>
          <FaMapMarkerAlt /> <p>{city}</p>
        </Styled.ProContactInfosLocationWrapper>
      ) : null}
      <DetailListContact
        {...contactInfo}
        blurred={!enableWhatsAppContact && !showContactInfo}
        labelMaxWidth="150px"
        blurredChildren={
          <Button color="blue" shrink onClick={onShowContactInfo} size="large">
            {translate('common.buttons.getCoords')}
          </Button>
        }
        onWhatsappClick={onWhatsappClick}
        enableWhatsAppContact={enableWhatsAppContact}
      />
    </Styled.ContactInfosContainer>
  );
};
